export default {
      id: "feuilles_menu-usage",
      viewBox: "0 0 235 370",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#feuilles_menu-usage",
      toString: function () {
        return this.url;
      }
    }